import { CALL_API, Schemas } from '../../common/middleware/api';
import globalize from '../../common/services/globalize';
import moment from 'moment';

export const WORKSHOP_PAYMENTS_REQUEST = 'WORKSHOP_PAYMENTS_REQUEST';
export const WORKSHOP_PAYMENTS_SUCCESS = 'WORKSHOP_PAYMENTS_SUCCESS';
export const WORKSHOP_PAYMENTS_FAILURE = 'WORKSHOP_PAYMENTS_FAILURE';

export const WORKSHOP_PAYMENT_FETCH_REQUEST = 'WORKSHOP_PAYMENT_GET_REQUEST';
export const WORKSHOP_PAYMENT_FETCH_SUCCESS = 'WORKSHOP_PAYMENT_GET_SUCCESS';
export const WORKSHOP_PAYMENT_FETCH_FAILURE = 'WORKSHOP_PAYMENT_GET_FAILURE';

export const WORKSHOP_PAYMENT_UPDATE_REQUEST = 'WORKSHOP_PAYMENT_UPDATE_REQUEST';
export const WORKSHOP_PAYMENT_UPDATE_SUCCESS = 'WORKSHOP_PAYMENT_UPDATE_SUCCESS';
export const WORKSHOP_PAYMENT_UPDATE_FAILURE = 'WORKSHOP_PAYMENT_UPDATE_FAILURE';

export const CANCEL_WORKSHOP_SESSION_REQUEST = 'CANCEL_WORKSHOP_SESSION_REQUEST';
export const CANCEL_WORKSHOP_SESSION_SUCCESS = 'CANCEL_WORKSHOP_SESSION_SUCCESS';
export const CANCEL_WORKSHOP_SESSION_FAILURE = 'CANCEL_WORKSHOP_SESSION_FAILURE';

export const RESTORE_CANCELLED_WORKSHOP_SESSION_REQUEST = 'RESTORE_CANCELLED_WORKSHOP_SESSION_REQUEST';
export const RESTORE_CANCELLED_WORKSHOP_SESSION_SUCCESS = 'RESTORE_CANCELLED_WORKSHOP_SESSION_SUCCESS';
export const RESTORE_CANCELLED_WORKSHOP_SESSION_FAILURE = 'RESTORE_CANCELLED_WORKSHOP_SESSION_FAILURE';

export const CANCEL_ALL_SESSIONS_WORKSHOP_PAYMENT_REQUEST = 'CANCEL_ALL_SESSIONS_WORKSHOP_PAYMENT_REQUEST';
export const CANCEL_ALL_SESSIONS_WORKSHOP_PAYMENT_SUCCESS = 'CANCEL_ALL_SESSIONS_WORKSHOP_PAYMENT_SUCCESS';
export const CANCEL_ALL_SESSIONS_WORKSHOP_PAYMENT_FAILURE = 'CANCEL_ALL_SESSIONS_WORKSHOP_PAYMENT_FAILURE';

export const CANCEL_AND_REFUND_SESSION_REQUEST = 'CANCEL_AND_REFUND_SESSION_REQUEST';
export const CANCEL_AND_REFUND_SESSION_SUCCESS = 'CANCEL_AND_REFUND_SESSION_SUCCESS';
export const CANCEL_AND_REFUND_SESSION_FAILURE = 'CANCEL_AND_REFUND_SESSION_FAILURE';

export const CANCEL_AND_REFUND_ALL_SESSIONS_REQUEST = 'CANCEL_AND_REFUND_ALL_SESSIONS_REQUEST';
export const CANCEL_AND_REFUND_ALL_SESSIONS_SUCCESS = 'CANCEL_AND_REFUND_ALL_SESSIONS_SUCCESS';
export const CANCEL_AND_REFUND_ALL_SESSIONS_FAILURE = 'CANCEL_AND_REFUND_ALL_SESSIONS_FAILURE';

export const WORKSHOP_PAYMENTS_EXPORT_REQUEST = 'WORKSHOP_PAYMENTS_EXPORT_REQUEST';
export const WORKSHOP_PAYMENTS_EXPORT_SUCCESS = 'WORKSHOP_PAYMENTS_EXPORT_SUCCESS';
export const WORKSHOP_PAYMENTS_EXPORT_FAILURE = 'WORKSHOP_PAYMENTS_EXPORT_FAILURE';

export const WORKSHOP_PAYMENT_SEND_INVOICE_REQUEST = 'WORKSHOP_PAYMENT_SEND_INVOICE_REQUEST';
export const WORKSHOP_PAYMENT_SEND_INVOICE_SUCCESS = 'WORKSHOP_PAYMENT_SEND_INVOICE_SUCCESS';
export const WORKSHOP_PAYMENT_SEND_INVOICE_FAILURE = 'WORKSHOP_PAYMENT_SEND_INVOICE_FAILURE';

export const RESCHEDULE_SESSION_REQUEST = 'RESCHEDULE_SESSION_REQUEST';
export const RESCHEDULE_SESSION_SUCCESS = 'RESCHEDULE_SESSION_SUCCESS';
export const RESCHEDULE_SESSION_FAILURE = 'RESCHEDULE_SESSION_FAILURE';

export const loadWorkshopPayments = (options) => ({
	[CALL_API]: {
		types: [WORKSHOP_PAYMENTS_REQUEST, WORKSHOP_PAYMENTS_SUCCESS, WORKSHOP_PAYMENTS_FAILURE],
		endpoint: 'api/workshopPayments',
		request: options,
		schema: Schemas.WORKSHOP_PAYMENTS_ARRAY
	},
	parentId: options && options.parentId
});

export const fetchWorkshopPayment = (id) => ({
	[CALL_API]: {
		types: [WORKSHOP_PAYMENT_FETCH_REQUEST, WORKSHOP_PAYMENT_FETCH_SUCCESS, WORKSHOP_PAYMENT_FETCH_FAILURE],
		endpoint: `api/workshopPayments/${id}`,
		schema: Schemas.WORKSHOP_PAYMENT
	}
});

export const updateWorkshopPayment = (id, workshopPayment) => ({
	[CALL_API]: {
		types: [WORKSHOP_PAYMENT_UPDATE_REQUEST, WORKSHOP_PAYMENT_UPDATE_SUCCESS, WORKSHOP_PAYMENT_UPDATE_FAILURE],
		endpoint: `api/workshopPayments/${id}`,
		method: 'PUT',
		request: workshopPayment,
		schema: Schemas.WORKSHOP_PAYMENT,
		form: 'workshopPayment'
	}
});

export const exportWorkshopPayments = (exportFormat, options, onSuccessEvent) => (dispatch, getState) => {
	dispatch({
		[CALL_API]: {
			types: [WORKSHOP_PAYMENTS_EXPORT_REQUEST, WORKSHOP_PAYMENTS_EXPORT_SUCCESS, WORKSHOP_PAYMENTS_EXPORT_FAILURE],
			endpoint: `api/workshopPayments/export/${exportFormat === 'Xero' ? 'xero' : ''}`,
			request: {
				...options,
				timeZone: globalize.getCurrentTimeZone(getState().configuration.franchisor)
			},
			onSuccessEvent
		},
		format: exportFormat,
		filename: () => `WorkshopPaymentReport-${moment().format('YYYY-MM-DD')}.${exportFormat === 'Xero' ? 'csv' : 'xlsx'}`
	});
}

export const sendInvoice = (id) => ({
	[CALL_API]: {
		types: [WORKSHOP_PAYMENT_SEND_INVOICE_REQUEST, WORKSHOP_PAYMENT_SEND_INVOICE_SUCCESS, WORKSHOP_PAYMENT_SEND_INVOICE_FAILURE],
		endpoint: `api/workshopPayments/${id}/sendInvoice`,
		method: 'PUT',
		schema: Schemas.WORKSHOP_PAYMENT
	}
});

export const cancelSession = (sessionId, onSuccessEvent) => ({
	[CALL_API]: {
		types: [CANCEL_WORKSHOP_SESSION_REQUEST, CANCEL_WORKSHOP_SESSION_SUCCESS, CANCEL_WORKSHOP_SESSION_FAILURE],
		endpoint: `api/childWorkshopSessions/cancel/${sessionId}`,
		method: 'PUT',
		schema: Schemas.WORKSHOP_PAYMENT,
		form: 'workshopPayment',
		onSuccessEvent
	}
});

export const restoreCancelledSession = (sessionId, onSuccessEvent) => ({
	[CALL_API]: {
		types: [RESTORE_CANCELLED_WORKSHOP_SESSION_REQUEST, RESTORE_CANCELLED_WORKSHOP_SESSION_SUCCESS, RESTORE_CANCELLED_WORKSHOP_SESSION_FAILURE],
		endpoint: `api/childWorkshopSessions/restoreCancelled/${sessionId}`,
		method: 'PUT',
		schema: Schemas.WORKSHOP_PAYMENT,
		form: 'workshopPayment',
		onSuccessEvent
	}
});

export const cancelAllSessions = (paymentId, onSuccessEvent) => ({
	[CALL_API]: {
		types: [CANCEL_ALL_SESSIONS_WORKSHOP_PAYMENT_REQUEST, CANCEL_ALL_SESSIONS_WORKSHOP_PAYMENT_SUCCESS, CANCEL_ALL_SESSIONS_WORKSHOP_PAYMENT_FAILURE],
		endpoint: `api/workshopPayments/cancel/${paymentId}`,
		method: 'PUT',
		schema: Schemas.WORKSHOP_PAYMENT,
		form: 'workshopPayment',
		onSuccessEvent
	}
});

export const cancelAndRefundSession = (sessionId, options, onSuccessEvent) => ({
	[CALL_API]: {
		types: [CANCEL_AND_REFUND_SESSION_REQUEST, CANCEL_AND_REFUND_SESSION_SUCCESS, CANCEL_AND_REFUND_SESSION_FAILURE],
		endpoint: `api/childWorkshopSessions/cancelAndRefund/${sessionId}`,
		method: 'PUT',
		request: options,
		schema: Schemas.WORKSHOP_PAYMENT,
		form: 'workshopPayment',
		onSuccessEvent
	}
});

export const cancelAndRefundAllSessions = (paymentId, options, onSuccessEvent) => ({
	[CALL_API]: {
		types: [CANCEL_AND_REFUND_ALL_SESSIONS_REQUEST, CANCEL_AND_REFUND_ALL_SESSIONS_SUCCESS, CANCEL_AND_REFUND_ALL_SESSIONS_FAILURE],
		endpoint: `api/workshopPayments/cancelAndRefund/${paymentId}`,
		method: 'PUT',
		request: options,
		schema: Schemas.WORKSHOP_PAYMENT,
		form: 'workshopPayment',
		onSuccessEvent
	}
});

export const rescheduleSession = (sessionId, newSessionId, onSuccessEvent) => ({
	[CALL_API]: {
		types: [RESCHEDULE_SESSION_REQUEST, RESCHEDULE_SESSION_SUCCESS, RESCHEDULE_SESSION_FAILURE],
		endpoint: `api/childWorkshopSessions/reschedule/${sessionId}/${newSessionId}`,
		method: 'PUT',
		schema: Schemas.WORKSHOP_PAYMENT,
		form: 'rescheduleForm',
		onSuccessEvent
	}
});